<template>
  <v-container class="mx-1" fluid v-if="languageData.calculationMaterialCosts">
      <v-col cols="12">
          <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null" class="elevation-0">
                <v-form ref="materialCostForm" v-model="validMaterialCostForm">
                    <p class="text-h5 mb-9">{{ languageData.calculationMaterialCosts.materialCostFormHead }}</p>
                    <v-row>
                        <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                        <v-text-field
                            v-model="data.name"
                            :rules="[(v) => !!v || languageData.calculationMaterialCosts.nameRequired]"
                            :label="languageData.calculationMaterialCosts.name"
                            outlined
                        ></v-text-field>
                        </v-col>
                        <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                        <v-text-field
                            v-model="data.price"
                            :label="languageData.calculationMaterialCosts.price"
                            :rules="[(v) => !!v || languageData.calculationMaterialCosts.priceRequired, v => ( v && v < 1000000000 ) || languageData.calculationMaterialCosts.maxPrice]"
                            min="0" step="0.01"
                            type="number"
                            append-icon="euro"
                            outlined
                        ></v-text-field>
                        </v-col>
                        <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                        <v-text-field
                            v-model="data.quantity"
                            :label="languageData.calculationMaterialCosts.quantity"
                            :rules="[(v) => !!v || languageData.calculationMaterialCosts.quantityRequired, v => ( v && v < 1000000000 ) || languageData.calculationMaterialCosts.maxQuantity]"
                            min="0" step="0.01"
                            type="number"
                            append-icon="euro"
                            outlined
                        ></v-text-field>
                        </v-col>
                         <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-select
                                :label="languageData.calculationMaterialCosts.uom"
                                v-model="data.uom"
                                :items="measureTypes"
                                :rules="[(v) => !!v || languageData.calculationMaterialCosts.uomRequired]"
                                item-value="value"
                                item-text="name"
                                outlined
                                >
                            <template slot='selection' slot-scope='{ item }'>
                                {{ languageData.measureTypes[item.value] }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ languageData.measureTypes[item.value] }}
                            </template>
                            </v-select>
                        </v-col>
                        <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                        <v-text-field
                            v-model="data.total"
                            :label="languageData.calculationMaterialCosts.total"
                            min="0" step="0.01"
                            type="number"
                            append-icon="euro"
                            outlined
                            disabled
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="end" style="padding: 0px 12px !important">
                        <v-btn
                            class="button-shadow mb-5"
                            color="primary"
                            style="padding-left: 25px !important; padding-right: 25px !important"
                            height="55px"
                            @click="saveMaterialCost">{{ layout === 'add' ? languageData.calculationMaterialCosts.saveMaterialCost : languageData.calculationMaterialCosts.updateMaterialCost }}</v-btn>
                    </v-row>
                </v-form>
            </v-card>
        </v-col>
  </v-container>
</template>

<script type="text/javascript">
import eventBus from "../../../../../event-bus/eventBus";
import moneyCalculationsHelper from "../../../../../helpers/moneyCalculationsHelper";
import measureTypes from "../../../../../enums/measureTypes";
 export default {
   name: "MaterialCostForm",
   props: {
    layout: String,
    materialCostData: Object
   },
   data() {
     return {
       data: {},
       rules: {},
       validMaterialCostForm: false,
       moneyCalculationsHelper: moneyCalculationsHelper,
       measureTypes: measureTypes,
     }
   },
   watch: {
    'data': {
        deep: true,
        handler: function(newValue) {
            if (newValue.price && newValue.quantity) {
                newValue.total = this.moneyCalculationsHelper.itemTotalNetProduct(Number(newValue.price), Number(newValue.quantity));
            }
        }
      },
   },
   methods: {
    saveMaterialCost() {
        if (this.$refs.materialCostForm && !this.$refs.materialCostForm.validate()) return
        this.rules = [];
        this.$refs.materialCostForm.resetValidation();
        if(this.layout === "edit") {
            eventBus.$emit('updateMaterialCost', this.data);
        } else {
            eventBus.$emit('addNewMaterialCost', this.data);
       }
    }
   },
   mounted() {
    if (this.layout === 'edit' && this.materialCostData) {
        this.data = this.materialCostData;
        this.$refs.materialCostForm.resetValidation();
    }
   },
 }
</script>